// Basic
import { useQueries } from 'react-query';
// Queries
import queryGetApiDocumentation from '@/app/modules/documentation/api/queries/getApiDocumentation';
import queryGetUserGuideDocumentation from '@/app/modules/documentation/api/queries/getUserGuideDocumentation';
import queryGetUserMerchantGuideDocumentation from '@/app/modules/documentation/api/queries/getUserMerchantGuideDocumentation';
import queryGetPayluddInitGuideDocumentation from '@/app/modules/documentation/api/queries/getPayluddInitGuideDocumentation';
import queryGetPayluddMerchantGuideDocumentation from '@/app/modules/documentation/api/queries/getPayluddMerchantGuideDocumentation';
// Components
import Page from '../../../common-utils/components/structure/page/Page';
import { Card } from '@/common-utils/components/ui/card';
import { CardHeader } from '@/common-utils/components/ui/card';
import Icon from '@/common-utils/components/renders/icon/Icon';
import Entity from '@/common-utils/components/renders/entity/Entity';
import logoPayludd from 'url:../../../../resource/images/payludd.png';
// Common
import RouteUrls from '@/app/root/enums/RouteUrls';
import CardDeck from '@/common-utils/components/renders/cardDeck/CardDeck';
import ICONS from '@/common-utils/enums/icons';
import Spinner from '@/common-utils/components/renders/spinner/Spinner';
import { useEffect, useState } from 'react';
import DOCUMENTATION_FIELDS from '@/app/modules/documentation/fields/DocumentationFields';
import useCustomPayStore from '@/app/store/customPay';
import useDeviceSizeStore from '@/app/store/deviceSize';
/**
 * @returns {JSX} Documentation
 */
function Documentation() {

    // Store
    const isCustomPay = useCustomPayStore(s => s.isCustomPay);
    const isSmallDevice = useDeviceSizeStore(s => s.isSmallDevice);
    const isMediumDevice = useDeviceSizeStore(s => s.isMediumDevice);
    const isLargeDevice = useDeviceSizeStore(s => s.isLargeDevice);
    const cardsNumberPerRow = isSmallDevice ? 2 : isMediumDevice ? 3 : isLargeDevice ? 5 : 1;

    // State
    const [documentationClicked, setDocumentationClicked] = useState();

    // API Calls
    const [
        getApiDocumentationResponse,
        getUserGuideDocumentationResponse,
        getUserMerchantGuideDocumentationResponse,
        getPayluddInitGuideDocumentationResponse,
        getPayluddMerchantGuideDocumentationResponse
    ] = useQueries([
        queryGetApiDocumentation(false),
        queryGetUserGuideDocumentation(false),
        queryGetUserMerchantGuideDocumentation(false),
        queryGetPayluddInitGuideDocumentation(false),
        queryGetPayluddMerchantGuideDocumentation(false)
    ]);


    const documentationData = [
        {
            entity: 'documentation.api_documentation',
            icon: <Icon icon={ICONS.API} className='text-primary' />,
            url: getApiDocumentationResponse.data?.[DOCUMENTATION_FIELDS.URL.key],
            refetch: getApiDocumentationResponse.refetch,
            isFetching: getApiDocumentationResponse.isFetching
        },
        {
            entity: 'documentation.user_guide',
            icon: <Icon icon={ICONS.USER_GUIDE} className='text-primary' />,
            url: getUserGuideDocumentationResponse.data?.[DOCUMENTATION_FIELDS.URL.key],
            refetch: getUserGuideDocumentationResponse.refetch,
            isFetching: getUserGuideDocumentationResponse.isFetching
        },
        {
            entity: 'documentation.user_merchant_guide',
            icon: <Icon icon={ICONS.USER_GUIDE} className='text-primary' />,
            url: getUserMerchantGuideDocumentationResponse.data?.[DOCUMENTATION_FIELDS.URL.key],
            refetch: getUserMerchantGuideDocumentationResponse.refetch,
            isFetching: getUserMerchantGuideDocumentationResponse.isFetching
        },
        {
            entity: 'documentation.payludd_guide',
            icon: <img src={logoPayludd} className='w-6 h-6' />,
            url: getPayluddInitGuideDocumentationResponse.data?.[DOCUMENTATION_FIELDS.URL.key],
            refetch: getPayluddInitGuideDocumentationResponse.refetch,
            isFetching: getPayluddInitGuideDocumentationResponse.isFetching,
            hidden: isCustomPay
        },
        {
            entity: 'documentation.merchant_payludd_guide',
            icon: <img src={logoPayludd} className='w-6 h-6' />,
            url: getPayluddMerchantGuideDocumentationResponse.data?.[DOCUMENTATION_FIELDS.URL.key],
            refetch: getPayluddMerchantGuideDocumentationResponse.refetch,
            isFetching: getPayluddMerchantGuideDocumentationResponse.isFetching,
            hidden: isCustomPay
        }
    ];

    // Hooks
    useEffect(() => {
        const docData = documentationData.find(doc => doc.entity === documentationClicked);
        if (docData?.url) {
            setDocumentationClicked(null);
            window.open(docData.url, '_blank');
        }
    }, [documentationClicked]);

    return (
        <Page>
            <Page.Header route={RouteUrls.DOCUMENTATION} routeBase={RouteUrls.DOCUMENTATION} />
            <Page.Body dataCy='page-documentation'>
                <CardDeck
                    cardsProps={documentationData}
                    component={
                        (doc, index) => <Card
                            key={doc.key || doc.entity || index}
                            className={doc.hidden ? 'invisible w-80 mx-2' : 'cursor-pointer w-80 mx-2'}
                            onClick={async () => {
                                await doc.refetch();
                                setDocumentationClicked(doc.entity);
                            }}
                        >
                            <CardHeader>
                                <div className='flex flex-col items-center gap-2 text-center'>
                                    {doc.icon}
                                    {
                                        doc.isFetching ? <Spinner className='logout-spinner' /> : <Entity entity={doc.entity} />
                                    }
                                </div>
                            </CardHeader>
                        </Card>
                    }
                    cardsNumberPerRow={cardsNumberPerRow}
                />
            </Page.Body>
        </Page>
    );
}

export default Documentation;